var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['message-abstract-video']},[_c('div',{staticClass:"message-abstract-video-box"},[_c('img',{class:['video-snapshot'],attrs:{"src":_setup.videoUrl}}),_c(_setup.Icon,{staticClass:"video-play",attrs:{"file":_setup.playIcon}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }